<div class="modal-header">
    <button type="button" class="btn-close" (click)="dismissModal()" aria-label="Close"></button>
</div>
<div class="modal-body">
    <p class="large text-center mb-3">{{prompt}}</p>
    <div class="d-flex justify-content-center align-items-center">
        <button type="button" class="btn me-3" [ngClass]="cancelBtnClass" (click)="dismissModal()">@if(cancelBtnIcon) { <fa-icon [icon]="cancelBtnIcon"></fa-icon> } {{cancelBtnText}}</button>
        <button type="button" focus-me class="btn" [ngClass]="okBtnClass" (click)="confirmModal()">@if(okBtnIcon) { <fa-icon [icon]="okBtnIcon"></fa-icon> } {{okBtnText}}</button>
    </div>
</div>